import { render, staticRenderFns } from "./ResumeRegions.vue?vue&type=template&id=da6d43d8"
import script from "./ResumeRegions.vue?vue&type=script&lang=js"
export * from "./ResumeRegions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports